module.exports = __webpack_public_path__ + "img/center-l.c9aa522b.png";